var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapp"},[_c('div',{staticClass:"title"},[_vm._v("订单： 董东钰 的拍照订单 套系名称：尊享会员一对一")]),_c('div',{staticClass:"photo-class"},_vm._l((_vm.photoCount),function(item,index){return _c('div',{key:index,staticClass:"item"},[_vm._v(" "+_vm._s(item.text)+" "),_c('span',[_vm._v(_vm._s(item.num))]),_vm._v("张 ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }